import {LeasePackageImportDto} from "../../../model/Imports";
import {useNavigate} from "react-router-dom";
import {useDisableImport, useEnableImport} from "../../../api/imports/useDisableEnableImports";
import {useDisableImportPackage, useEnableImportPackage} from "../../../api/imports/useDisableEnableImportsPackages";
import {useDisableImportVehicle, useEnableImportVehicle} from "../../../api/imports/useDisableEnableImportsVehicles";
import notifier from "simple-react-notifications2";
import {Accordion, Button, Col, Row, Badge} from "react-bootstrap";
import {Loading} from "../../../components/Loading";
import React, {useEffect, useState} from "react";
import {useGetVehicleOverride} from "../../../api/vehicle/useVehicleOverrides";

// Updated interface to match the API response
interface VehicleOverrideDto {
    colors: string[];
    delivery: string[];
    specialEquipment: string | null;
    deliveryFromWeeks: number | null;
    deliveryToWeeks: number | null;
}

export function VehicleWithPackages(
    props: {import: LeasePackageImportDto, reload: () => void}
) {
    const navigate = useNavigate();

    const {loading: loadingEnable, error: errorEnable, execute: executeEnable} = useEnableImport();
    const {loading: loadingDisable, error: errorDisable, execute: executeDisable} = useDisableImport();
    const {loading: loadingEnablePackage, error: errorEnablePackage, execute: executeEnablePackage} = useEnableImportPackage();
    const {loading: loadingDisablePackage, error: errorDisablePackage, execute: executeDisablePackage} = useDisableImportPackage();
    const {loading: loadingEnableVehicle, error: errorEnableVehicle, execute: executeEnableVehicle} = useEnableImportVehicle();
    const {loading: loadingDisableVehicle, error: errorDisableVehicle, execute: executeDisableVehicle} = useDisableImportVehicle();

    // Helper function to check if an override has meaningful data

    const vehicleOverrides = props.import.vehicleOverrides.reduce((vehicle, override) => {
        vehicle[override.vehicleId] = override;
        return vehicle;
    }, {} as Record<number, VehicleOverrideDto>);
    const hasValidData = (override: VehicleOverrideDto | null): boolean => {
        if (!override) return false;
        return (
            (override.colors && override.colors.length > 0) ||
            (override.delivery && override.delivery.length > 0) ||
            (override.specialEquipment && override.specialEquipment.trim() !== '') ||
            (override.deliveryFromWeeks !== null && override.deliveryFromWeeks > 0) ||
            (override.deliveryToWeeks !== null && override.deliveryToWeeks > 0)
        );
    };

    function enable(id: number) {
        executeEnable(id).then(r => {
            notifier.success("enabled")
        }).finally(() => props.reload())
    }

    function disable(id: number) {
        executeDisable(id).then(r => {
            notifier.warn("disabled")
        }).finally(() => props.reload())
    }

    return (
        <>
            <Row>
                <Col>
                    {(loadingDisable || loadingEnable) && (<Loading/>)}
                    <Button className="button-outline" size={"sm"} onClick={() => {
                        if(props.import.enabled) {disable(props.import.id)} else {enable(props.import.id)}
                    }}>
                        {props.import.enabled ? 'Disable' : 'Enable'}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Accordion>
                    {props.import.vehiclePackages.map((it, index) => {
                        const override = vehicleOverrides[it.vehicle.id];
                        const hasOverride = hasValidData(override);

                        return (
                            <Accordion.Item key={'Ims-v' + index} eventKey={index.toString()}>
                                <Accordion.Header>
                                    <Row className="w-100">
                                        <Col>Id: {it.vehicle.id}</Col>
                                        <Col>{it.vehicle.brand}</Col>
                                        <Col>{it.vehicle.model}</Col>
                                        <Col>Doors: {it.vehicle.numberOfDoors}</Col>
                                        <Col>KW: {it.vehicle.maximumPowerKw}</Col>
                                        <Col>Range: {it.vehicle.rangeKm}</Col>
                                        <Col>Trim: {it.vehicle.trimLevel}</Col>
                                        <Col>Body: {it.vehicle.bodyType}</Col>
                                        {/* Show badge if vehicle has an override */}
                                        {hasOverride && (
                                            <Col>
                                                <Badge bg="warning">Has Override</Badge>
                                            </Col>
                                        )}
                                        <Col>
                                            <div onClick={() => navigate(`/vehicles/${it.vehicle.id}`)} className="button btn-outline-primary">Edit</div>
                                            <div onClick={() => navigate(`/vehicles/${it.vehicle.id}/imports/${props.import.id}/override`)} className="button btn-outline-primary">
                                                {hasOverride ? 'Edit override' : 'Add override'}
                                            </div>
                                            <div onClick={() => executeDisableVehicle(props.import.id, it.vehicle.id).finally(props.reload)} className="button btn-outline-primary">Deactivate for vehicle</div>
                                            <div onClick={() => executeEnableVehicle(props.import.id, it.vehicle.id).finally(props.reload)} className="button btn-outline-primary">Activate for vehicle</div>
                                        </Col>
                                    </Row>
                                </Accordion.Header>
                                <Accordion.Body>
                                    {it.leasePackages && it.leasePackages.sort((a, b) => a.kmPerYear - b.kmPerYear).map((p, indexP) => (
                                        <Row key={`pcks-${indexP}`}>
                                            <Col>{p.kmPerYear}km</Col>
                                            <Col>{p.durationMonths} Months</Col>
                                            <Col>id: {p.offerId}</Col>
                                            <Col>Monthly: {p.totalMonthlyNetCostEur}</Col>
                                            <Col>Monthly gross: {p.totalMonthlyGrossCostEur}</Col>
                                            <Col>Monthly comparison gross: {p.grossComparisonCostEur}</Col>
                                            <Col>Gross: {p.grossRetailPriceEur}</Col>
                                            <Col>Tires: {p.tires}</Col>
                                            <Col>Active: {p.active ? 'True' : 'False'}</Col>
                                            <Col>
                                                {p.active && (
                                                    <div onClick={() => executeDisablePackage(props.import.id, p.id).finally(props.reload)} className="button btn-outline-primary">Deactivate</div>
                                                )}
                                                {!p.active && (
                                                    <div onClick={() => executeEnablePackage(props.import.id, p.id).finally(props.reload)} className="button btn-outline-primary">Activate</div>
                                                )}
                                            </Col>
                                        </Row>
                                    ))}
                                </Accordion.Body>
                            </Accordion.Item>
                        );
                    })}
                </Accordion>
            </Row>
        </>
    )
}